import { Devi_inactivityCheck } from '../Devi/Devi.inactivity'
import { IDB_posts } from '../IDB/IDB.dexie'
import { IDB_reportWrite } from '../IDB/IDB.table.report'
import { Logg_event } from '../Logg/Logg.event'
import { Logg_timer } from '../Logg/Logg.timer'
import { Rpts_makeLocationTimelineEventRedundant } from './Rpts.makeLocationTimelineEventRedundant'
import { Rpts_prepareReportsForUpload } from './Rpts.prepareReportsForUpload'
import { Serv_send } from '../Serv/Serv.socketClient'
import { Imag_photosPrune } from '../Imag/Imag.Photo'
import { Logg_createLogger } from '../Logg/Logg.Logger'

export async function Rpts_upload() {
    const logger = Logg_createLogger(`Rpts_upload`)

    Logg_event('Start', { label: 'ReportsUpload' })
    const timer = Logg_timer()

    const reports = await Rpts_prepareReportsForUpload(logger)

    for (const { reportToSave, reportToSend } of reports) {
        const reportClientId = reportToSave.clientId
        try {
            // Do not upload until calendar event has uploaded
            if (reportToSave.event?.onlineId == null) {
                logger.log(`report has no calendar event or it's not been uploaded`, { reportClientId })
                continue
            }

            logger.log(`report to be uploaded`, { reportClientId })
            const response = await Serv_send('v2.reports.add', reportToSend).catch(() => ({ id: undefined }))
            if (response.id === undefined) {
                logger.warn(`report failed to be uploaded`, { reportClientId })
                continue
            }

            logger.log(`report uploaded successfully`, { reportClientId })

            // Update Report
            reportToSave.onlineId = response.id
            reportToSave.uploaded = true

            await IDB_reportWrite(logger, reportToSave)

            logger.log(`report updated report in idb`, { reportClientId })

            await IDB_posts().where({ reportClientId: reportToSave.clientId }).modify({
                status: 'synced',
                report: reportToSave.onlineId,
            })

            logger.log(`report updated report post`, { reportClientId })

            await Rpts_makeLocationTimelineEventRedundant(reportToSave)
        } catch (error) {
            logger.error(error, { reportClientId })
        }
    }

    // check and delete photos from indexed db which have been uploaded
    await Imag_photosPrune()

    // Check if it's no safe to logout if inactive
    Devi_inactivityCheck()

    Logg_event('ReportsUploadEnd', {
        duration: timer.getDurationInWholeSeconds(),
        reportUploadsCount: reports.length,
    })

    logger.log(`done`)
}
